import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'

// Input modality for focus rings (see :focus-visible in design.css). Only
// Tab and the arrow keys count as keyboard navigation; Enter on a touch
// keyboard or a tap switches back to pointer, so no ring appears on the next
// screen's first option.
const NAV_KEYS = new Set(['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'])
document.documentElement.dataset.nav = 'pointer'
window.addEventListener('keydown', (e) => {
  if (NAV_KEYS.has(e.key)) document.documentElement.dataset.nav = 'keyboard'
}, true)
window.addEventListener('pointerdown', () => { document.documentElement.dataset.nav = 'pointer' }, true)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Service worker: check for updates when the tab regains focus, and let the
// app decide when to apply them. Never reload underneath someone mid-assessment.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) registration.update()
        })

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (!newWorker) return
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent('bs:update-available', { detail: newWorker }))
            }
          })
        })

        let refreshing = false
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return
          refreshing = true
          window.location.reload()
        })
      })
      .catch((error) => {
        console.warn('ServiceWorker registration failed:', error)
      })
  })
}
